import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, ArrowRight } from 'lucide-react';

export const BackButton = ({ className = '', to = null, onClick = null }) => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const isRTL = i18n.language === 'ar' || i18n.language === 'fa';

  const handleBack = () => {
    if (onClick) {
      onClick();
    } else if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  const texts = {
    ar: 'رجوع',
    sv: 'Tillbaka',
    en: 'Back',
    tr: 'Geri',
    fa: 'بازگشت',
    so: 'Dib u noqo',
    pl: 'Wstecz',
    es: 'Atrás',
    de: 'Zurück'
  };

  return (
    <button
      onClick={handleBack}
      className={`inline-flex items-center gap-2 px-4 py-2 bg-white border-2 border-slate-200 rounded-xl text-slate-700 font-semibold hover:bg-slate-50 hover:border-slate-300 hover:text-slate-900 transition-all duration-200 shadow-sm ${className}`}
      data-testid="back-button"
    >
      {isRTL ? (
        <ArrowRight className="w-5 h-5" />
      ) : (
        <ArrowLeft className="w-5 h-5" />
      )}
      <span>{texts[i18n.language] || texts.en}</span>
    </button>
  );
};

export default BackButton;
